import { styled } from "goober";

// Shared vertical bar-chart primitives for the monitoring dashboard, used by both
// "Execution volume by space" and (in its collapsed modes) "Spend by model" so
// the two charts read identically.

export const Columns = styled("div")`
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  flex: 1;
`;

// The column wrapper's styles, shared so an interactive (PressButton) and a
// plain (div) column can look identical.
export const barColumnStyles = `
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  transition: opacity 120ms ease;
`;

export const BarColumn = styled("div")`
  ${barColumnStyles}
`;

export const BarRow = styled("div")`
  width: 100%;
  flex: 1;
  min-height: 100px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const Bar = styled("div")`
  border-radius: 999px;
  transition:
    width 120ms ease,
    opacity 120ms ease,
    filter 120ms ease;
`;

export const ColumnMeta = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;
`;
